import { ClipboardList, Compass, Footprints } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    title: "1. Take the assessment",
    body:
      "A short, honest questionnaire about your skills, your situation, and what actually matters to you right now.",
    testid: "how-step-1",
  },
  {
    icon: Compass,
    title: "2. Get your direction",
    body:
      "We translate your answers into a personalised plan — roles that fit you, skills worth building, and what to deprioritise.",
    testid: "how-step-2",
  },
  {
    icon: Footprints,
    title: "3. Walk it one step at a time",
    body:
      "Weekly, bite‑sized actions and check‑ins. No motivational fluff — just the next concrete thing to do.",
    testid: "how-step-3",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="bg-white py-24 lg:py-32"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          <p className="text-sm uppercase tracking-[0.18em] text-sky-700 font-medium">
            How it works
          </p>
          <h2
            className="mt-4 text-3xl lg:text-4xl tracking-tight leading-tight font-medium text-slate-900"
            data-testid="how-it-works-heading"
          >
            {`Three calm steps from "what now?" to "here's my next move."`}
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Designed to be done in evenings, on lunch breaks, or whenever you
            have a quiet half hour.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {STEPS.map((s) => (
            <div
              key={s.title}
              className="bg-white border border-slate-100 rounded-2xl p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300"
              data-testid={s.testid}
            >
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-sky-50 text-sky-700 mb-6">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="text-xl font-medium text-slate-900">{s.title}</h3>
              <p className="mt-3 text-base text-slate-600 leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
